<template lang="pug">
  div(data-testid="card-tab-overall-attachs")
    a.pull-right(v-if="editable", href="#" @click.prevent="openAddModal", data-testid="-btn-add") 追加

    p.lead
      i.fa.fa-fw.fa-paperclip
      |
      |
      span 添付ファイル

    attachments-list(
      v-model="attachments",
      :editable="editable",
      :class="{'bcard-field-editted': isFieldEditted}",
      @download="download",
      @openEditModal="openEditModal",
      @openDelModal="openDelModal"
    )

    portal(to="modal")
      //- 添付ファイルの追加・変更
      form(ref="form", @submit.prevent="modalEdit.isNew ? postData() : putData()", data-testid="bcard-attachment-modal")
        app-modal(v-model="modalEdit.isOpen" data-testid="-submit-attachment-modal")
          template(slot="title") 添付ファイルの{{modalEdit.isNew ? '追加' : '変更'}}
          app-messages(:errorMessages="errors")
          attachment-form(v-model="modalEdit.value", :is-edit="!modalEdit.isNew", @download="download")
          template.modal-footer(slot="footer" slot-scope="{close}")
            button.btn.btn-primary(type="submit" data-testid="-btn-submit") {{modalEdit.isNew ? '追加' : '変更'}}
            button.btn.btn-default(type="button", @click.prevent="close" data-testid="-btn-cancel") キャンセル
            template(v-if="!modalEdit.isNew")
              | &nbsp;
              .btn-separator
              | &nbsp;
              button.btn.btn-danger(type="button", @click.prevent="delData(modalEdit.value.sid_attach)" data-testid="-btn-delete") 削除

      //- 添付ファイルの削除
      app-modal(type="danger" v-model="modalDel.isOpen" data-testid="bcard-attachment-delete-modal")
        template(slot="title")  添付ファイルの削除
        app-messages(:errorMessages="errors")
        h4 この添付ファイルを削除します。よろしいですか？
        p.text-danger ※削除したファイルは元に戻せません。
        template.modal-footer(slot="footer" slot-scope="{close}")
          button.btn.btn-danger(type="button" @click.prevent="delData" data-testid="-btn-delete") 削除
          button.btn.btn-default(type="button" @click.prevent="close") キャンセル
</template>

<script>
import mixinForm from '@/mixins/form'
import AppModal from '@/components/templates/AppModal'
import AppMessages from '@/components/molecules/AppMessages'
import AttachmentsList from '@/components/organisms/lists/AttachmentsList'
import AttachmentForm from '@/components/organisms/forms/AttachmentForm'
import RepositoryFactory from '@/repositories/RepositoryFactory'

const AttachmentRepository = RepositoryFactory.get('attachment')

export default {
  name: 'CardTabOverallAttachs',
  components: { AppModal, AppMessages, AttachmentsList, AttachmentForm },
  mixins: [ mixinForm ],
  props: {
    /**
     * @var sid_person
     */
    value: { type: [String, Number], required: false, default: '' },
    editable: { type: Boolean, required: true }
  },
  data () {
    return {
      attachments: [],
      isFieldEditted: false,
      isDownloading: false, // ダウンロード中
      modalEdit: {
        isOpen: false,
        value: {}
      },
      // 添付削除
      modalDel: {
        isOpen: false,
        value: {}
      }
    }
  },
  watch: {
    value (id) {
      if (id) {
        this.getList(id)
      }
    }
  },
  created () {
    // poratl内のformにrefがある場合の処理
    this.setFormInPortalWhenCreated()

    if (this.value) {
      this.getList(this.value)
    }
  },
  methods: {
    getList (sidPerson) {
      const vm = this
      AttachmentRepository.getList(sidPerson, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.attachments = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '添付ファイルを取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    download (value) {
      const vm = this
      // ダウンロード中ではない場合のみ実行する
      if (this.isDownloading === false) {
        this.isDownloading = true

        // ダウンロード処理を行う
        this.getFileDL('file', 'getFileByUrl', value.dispname, value.attach_url, this.isMgmt)
          .finally(function () {
            vm.isDownloading = false
          })
      }
    },
    // 追加ダイアログを開く
    openAddModal () {
      this.clearErrorMessages()
      this.modalEdit.value = {}
      this.modalEdit.isNew = true
      this.modalEdit.isOpen = true
    },
    postData () {
      const vm = this
      const sidPerson = this.value
      const formData = new FormData(this.$refs.form)

      this.isFieldEditted = false
      this.clearErrorMessages()

      AttachmentRepository.postList(sidPerson, formData, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.getList(vm.value)
            vm.showToast('添付ファイルを追加しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '添付ファイルを追加できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    // 変更ダイアログを開く
    openEditModal (attach = null) {
      this.clearErrorMessages()

      this.modalEdit.isNew = false
      this.modalEdit.isOpen = true

      // 一覧のデータを初期表示しておく
      this.modalEdit.value = Object.assign({}, attach) // 参照コピーではなく値コピー

      // DBからリアルタイムのデータを取得する
      const vm = this
      AttachmentRepository.get(attach.sid_attach, this.isMgmt)
        .then(function (response) {
          const data = vm.getApiData(response).data
          vm.modalEdit.value = data
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '添付ファイルの詳細情報を取得できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    putData () {
      const vm = this
      const sidAttach = this.modalEdit.value.sid_attach
      const formData = new FormData(this.form)

      this.isFieldEditted = false
      this.clearErrorMessages()

      AttachmentRepository.put(sidAttach, formData, this.isMgmt)
        .then(function (response) {
          if (vm.isApiSuccess(response)) {
            vm.getList(vm.value)
            vm.showToast('添付ファイルを変更しました。', { type: 'success' })
            vm.modalEdit.isOpen = false
            vm.isFieldEditted = true
          }
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '添付ファイルを変更できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    },
    // 削除ダイアログを開く
    openDelModal (attach) {
      this.clearErrorMessages()
      this.modalEdit.value = attach
      this.modalDel.isOpen = true
    },
    // 削除実行
    delData () {
      const vm = this
      const sidAttach = this.modalEdit.value.sid_attach

      AttachmentRepository.delete(sidAttach, this.isMgmt)
        .then(function (response) {
          vm.getList(vm.value)
          vm.showToast('添付ファイルを削除しました。', { type: 'success' })
          // 削除確認ダイアログを閉じる
          vm.modalDel.isOpen = false
          // 追加・変更ダイアログも閉じる
          vm.modalEdit.isOpen = false
        })
        .catch(function (error) {
          const message = vm.getErrorMessage(error) || '添付ファイルを削除できませんでした。'
          vm.showToast(message, { type: 'danger' })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/box/CardTabOverallAttachs.vue